window.addEventListener('DOMContentLoaded',function(){
	const identityNumberField = document.querySelector('[name="attributes[identity-number]"]'),
          propertyField = document.querySelector('[name="attributes[property-designation]"]')
    
    //Validation TODO
    identityNumberField.addEventListener('input', () => {
    	console.log(identityNumberField.value)
	});

    propertyField.addEventListener('input', () => {
    	console.log(propertyField.value)
	});

});